import type { CrewMember } from "@/mocks/admin/crew";

const monthlyHours = [
  { month: "Jan", value: 142 },
  { month: "Feb", value: 158 },
  { month: "Mar", value: 168 },
  { month: "Apr", value: 152 },
  { month: "May", value: 174 },
  { month: "Jun", value: 38 },
];

export default function PerformancePanel({ member }: { member: CrewMember }) {
  const max = Math.max(...monthlyHours.map((m) => m.value));
  const total = monthlyHours.reduce((s, m) => s + m.value, 0);
  const ytdPay = Math.round(total * member.hourlyRate);

  return (
    <div className="bg-white border border-ink-100 rounded-lg p-5">
      <div className="flex items-center justify-between mb-1">
        <h3 className="font-display text-base font-bold text-ink-900">Performance</h3>
        <span className="text-[11px] text-ink-500">YTD 2026</span>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-4 mb-5">
        <div className="bg-cream-50 border border-ink-100 rounded-md p-3">
          <div className="text-[10px] uppercase tracking-wider text-ink-400 font-semibold">Hours</div>
          <div className="font-display text-xl font-bold text-ink-900 mt-0.5">{total}</div>
        </div>
        <div className="bg-cream-50 border border-ink-100 rounded-md p-3">
          <div className="text-[10px] uppercase tracking-wider text-ink-400 font-semibold">Pay (YTD)</div>
          <div className="font-display text-xl font-bold text-ink-900 mt-0.5">
            ${(ytdPay / 1000).toFixed(1)}k
          </div>
        </div>
        <div className="bg-cream-50 border border-ink-100 rounded-md p-3">
          <div className="text-[10px] uppercase tracking-wider text-ink-400 font-semibold">Avg Rating</div>
          <div className="font-display text-xl font-bold text-ink-900 mt-0.5 inline-flex items-center gap-1">
            <i className="ri-star-fill text-amber-500 text-sm"></i>
            {member.rating}
          </div>
        </div>
        <div className="bg-cream-50 border border-ink-100 rounded-md p-3">
          <div className="text-[10px] uppercase tracking-wider text-ink-400 font-semibold">Moves</div>
          <div className="font-display text-xl font-bold text-ink-900 mt-0.5">
            {member.completedMoves}
          </div>
        </div>
      </div>

      <div className="text-[10px] uppercase tracking-wider text-ink-400 font-semibold mb-2">
        Hours worked by month
      </div>
      <div className="flex items-end justify-between gap-2 h-32 mt-1">
        {monthlyHours.map((m, idx) => {
          const h = Math.max(6, (m.value / max) * 100);
          const isCurrent = idx === monthlyHours.length - 1;
          return (
            <div key={m.month} className="flex-1 flex flex-col items-center gap-1.5 group">
              <div className="text-[10px] font-bold text-ink-700 opacity-0 group-hover:opacity-100 transition-opacity tabular-nums">
                {m.value}h
              </div>
              <div className="w-full bg-cream-100 rounded-md flex-1 flex items-end overflow-hidden">
                <div
                  className={`w-full rounded-md transition-colors ${
                    isCurrent ? "bg-brand-500" : "bg-ink-800 group-hover:bg-ink-700"
                  }`}
                  style={{ height: `${h}%` }}
                ></div>
              </div>
              <div className="text-[11px] font-semibold text-ink-500">{m.month}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}